import { Ajax } from './../Core/Ajax';
import { Constants } from './../Core/Constants';
import { Storage } from './../Core/Storage';
import { AppStore } from './../Core/AppStore';
import { CartProvider } from './CartProvider'

export class CheckoutProvider {

	static getDeliveryOptions(success) {
		let cart = Storage.instance().cart;
		Ajax.post(Constants.Url.DeliveryOptions,cart, (data) => {
			success(data);
		});
	}

	static calculate(success) {
		let cart = Storage.instance().cart;
		Ajax.post(Constants.Url.CalculateOrder, cart, (data) => {
			success(data);
		});
	}

	static loadDeliveryPlaces(shippingId, success) {
		Ajax.get(Constants.Url.DeliveryPlaces, "shippingId=" + shippingId, (data) => {
			success(data);
		});
	}

	static placeOrder(totalValue,success,fail) {
		let order = Storage.instance().cart;
		let customer = Storage.instance().customer;
		let productsUtmSource = Storage.instance().productsUtmSource ?? [];
		order.remarks = customer.remarks;
		order.totalPriceExclVat = totalValue;
		order.invoiceContact = customer.invoiceContact;
		if (customer.deliveryContact) {
			order.deliveryContact = customer.deliveryContact;
			order.deliveryContact.email = customer.invoiceContact.email; 
			order.deliveryContact.phone = customer.invoiceContact.phone; 
		}
		var rnd = Math.floor(Math.random() * 1000);
		Ajax.post(Constants.Url.PlaceOrder + '?ts=' + rnd, order, (data) => {
			//pokud je to ok, smazu kosik
			CartProvider.clearAfterSubmit();
			AppStore.set({ confirmedOrder: data });
			success();
		},(err)=>{if (fail)fail(err)});
	}

	static repeatPayment(invc, time) {
		return Ajax.postPlain(Constants.Url.RepeatPayment, { invoiceCode: invc, createdTicks: time })
			.then((data) => {
				AppStore.set({ confirmedOrder: data });
				return data;
			});
	}
}
